// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__9tVOF","item":"PaymentsMobile_item__3HMuu","label":"PaymentsMobile_label__3guIS","amount":"PaymentsMobile_amount__2WL41"};